import { ConstantEntity, ConstantGroup } from './base.constants';

const ACTIVATE_ACCOUNT = new ConstantEntity({
  value: 0,
  name: 'ACTIVATE_ACCOUNT',
  translationTag: 'actionTokenKind',
});

const CHANGE_PASSWORD = new ConstantEntity({
  value: 1,
  name: 'CHANGE_PASSWORD',
  translationTag: 'actionTokenKind',
});

const CHANGE_EMAIL = new ConstantEntity({
  value: 2,
  name: 'CHANGE_EMAIL',
  translationTag: 'actionTokenKind',
});

const PASSWD_CONFIRM_INVITATION = new ConstantEntity({
  value: 3,
  name: 'PASSWD_CONFIRM_INVITATION',
  translationTag: 'actionTokenKind',
});

const REGISTER_COMPANY = new ConstantEntity({
  value: 4,
  name: 'REGISTER_COMPANY',
  translationTag: 'actionTokenKind',
});

const ACTION_TOKEN_KINDS: ConstantEntity[] = [
  ACTIVATE_ACCOUNT,
  CHANGE_PASSWORD,
  CHANGE_EMAIL,
  PASSWD_CONFIRM_INVITATION,
  REGISTER_COMPANY,
];

export class ActionTokenKindsConstants extends ConstantGroup {
  list(): ConstantEntity[] {
    return ACTION_TOKEN_KINDS;
  }

  static get ACTIVATE_ACCOUNT() {
    return ACTIVATE_ACCOUNT;
  }

  static get CHANGE_PASSWORD() {
    return CHANGE_PASSWORD;
  }

  static get CHANGE_EMAIL() {
    return CHANGE_EMAIL;
  }

  static get PASSWD_CONFIRM_INVITATION() {
    return PASSWD_CONFIRM_INVITATION;
  }

  static get REGISTER_COMPANY() {
    return REGISTER_COMPANY;
  }
}
